{
  "name": "angular-webapp-v2",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:proxy": "ng serve --proxy-config proxy.conf.json",
    "build": "ng build --configuration production",
    "test": "jest",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "analyze": "npm run build -- --stats-json && webpack-bundle-analyzer dist/angular-webapp-v2/stats.json",
    "p:verify": "prettier --config ./.prettierrc --list-different \"src/{app,components,environments,models,pages,services}/**/*{.ts,.html,.scss}\"",
    "p:fix": "prettier --write \"src/{app,components,environments,models,pages,services,styles}/**/*{.ts,.html,.scss}\"",
    "doc": "npx compodoc -p tsconfig.doc.json",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "prepare": "husky"
  },
  "jest": {
    "preset": "jest-preset-angular",
    "setupFilesAfterEnv": [
      "<rootDir>/src/setup-jest.ts"
    ],
    "testPathIgnorePatterns": [
      "<rootDir>/node_modules/",
      "<rootDir>/dist/"
    ],
    "transform": {
      "^.+\\.(ts|mjs|js|html)$": [
        "jest-preset-angular",
        {
          "tsconfig": "<rootDir>/tsconfig.spec.json",
          "stringifyContentPathRegex": "\\.html$"
        }
      ]
    }
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.25",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "20.3.25",
    "@angular/compiler": "20.3.25",
    "@angular/core": "20.3.25",
    "@angular/forms": "20.3.25",
    "@angular/platform-browser": "20.3.25",
    "@angular/platform-browser-dynamic": "20.3.25",
    "@angular/router": "20.3.25",
    "@azure/msal-angular": "^4.0.19",
    "@azure/msal-browser": "^4.22.0",
    "@microsoft/applicationinsights-angularplugin-js": "^15.3.4",
    "@microsoft/applicationinsights-clickanalytics-js": "^3.3.4",
    "@microsoft/applicationinsights-web": "^3.3.4",
    "@primeng/themes": "^20.4.0",
    "@primeuix/themes": "^2.0.3",
    "bootstrap": "^5.3.3",
    "canvg": "^3.0.11",
    "chart.js": "^4.5.0",
    "form-data": "^4.0.4",
    "html2canvas": "^1.4.1",
    "http-proxy-middleware": "^3.0.7",
    "jspdf": "^4.2.1",
    "moment": "^2.30.1",
    "ngx-json-viewer": "^3.2.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.4.0",
    "prismjs": "^1.30.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.7.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "19.0.1",
    "@angular-eslint/eslint-plugin": "19.0.1",
    "@angular-eslint/eslint-plugin-template": "19.0.1",
    "@angular-eslint/schematics": "19.0.1",
    "@angular-eslint/template-parser": "19.0.1",
    "@angular/build": "^20.3.26",
    "@angular/cli": "^20.3.26",
    "@angular/compiler-cli": "20.3.25",
    "@compodoc/compodoc": "^1.1.25",
    "@cypress/schematic": "^2.5.2",
    "@types/jest": "^29.5.13",
    "@types/node": "^18.19.54",
    "@typescript-eslint/eslint-plugin": "8.42.0",
    "@typescript-eslint/parser": "8.42.0",
    "cypress": "15.15.0",
    "eslint": "^8.57.0",
    "husky": "^9.1.6",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.2.4",
    "license-webpack-plugin": "^4.0.2",
    "prettier": "^3.3.3",
    "pretty-quick": "^4.0.0",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.3",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "overrides": {
    "@angular/build": {
      "@vitejs/plugin-basic-ssl": "2.3.0",
      "esbuild": "0.28.1",
      "vite": "7.3.5"
    },
    "@compodoc/compodoc": {
      "@angular-devkit/core": "21.2.12",
      "@angular-devkit/schematics": "21.2.12",
      "uuid": "11.1.1"
    },
    "@cypress/request": {
      "qs": "6.15.2"
    },
    "http-auth": {
      "uuid": "11.1.1"
    },
    "piscina": "5.2.0",
    "js-yaml": "5.0.0",
    "@babel/core": "7.29.7",
    "sockjs": {
      "uuid": "11.1.1"
    }
  }
}
